<template>
    <div class="sidebar rounded text-left" :class="{'h-open': open}">
        <div class="relative lg:max-w-sm 2xl:max-w-md bg-white h-full p-4 shadow overflow-y-auto">
            <div class="flex justify-between md:justify-center">
                <h1 class="font-bold text-2xl">COVID-19 Cruise Tracker</h1>
                <div class="block md:hidden ml-2">
                   <button @click="open = !open" class="bg-gray-200 rounded border">
                       <svg v-if="!open" fill="currentColor" viewBox="0 0 20 20" class="w-8 h-8"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                       <svg v-else fill="currentColor" viewBox="0 0 20 20" class="w-8 h-8"><path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clip-rule="evenodd"></path></svg>
                   </button>
               </div>
            </div>
            <div class="md:block" :class="{'hidden': !open}">
<!--                <div class="bg-blue-200 p-2 rounded shadow my-3">-->
<!--                    <p class="font-semibold">Join the cruise tracker data team</p>-->
<!--                    <p class="text-sm mt-">-->
<!--                        We're looking for volunteers to help us keep this site up to date & expand our data.-->
<!--                        Please <a class="text-blue-600 hover:text-blue-700" href="mailto:covid@atymic.dev">send us an email</a> if you're interested in helping 😊</p>-->
<!--                </div>-->
                <div>
                    <div class="flex justify-center mt-2">
                        <button class="bg-gray-200 text-sm hover:bg-blue-200 rounded py-1 px-4" @click="showAbout = true">About & Credits</button>
                        <a target="_blank" href="mailto:covid@atymic.dev" class="bg-gray-200 text-sm hover:bg-blue-300 rounded py-1 px-4 ml-4" @click="showAbout = true">Contact Us</a>
                    </div>
                    <modal :open="showAbout" @close="showAbout = false">
                        <div class="max-w-xl w-full bg-white rounded-lg shadow-2xl px-6 py-6 text-left">
                            <div class="border-b-2 border-gray-200 pb-4 flex justify-between items-center">
                                <h2 class="font-semibold text-gray-900 text-2xl leading-tight">About the Tracker</h2>
                                <div>
                                    <button @click="showAbout = false" class="p-1">
                                        <svg fill="currentColor" viewBox="0 0 20 20" class="text-gray-600 hover-blue-600 w-6 h-6"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                                    </button>
                                </div>
                            </div>
                            <p class="mt-4 text-gray-700">We built this tool to keep track of all the cruise ships around the world during the COVID-19 crisis. We aim to provide up to date and accurate information on all of the cruise ships out there.</p>
                            <h3 class="font-bold mt-6 mb-3 text-gray-800 text-center text-xl">The Team 👊</h3>
                            <div class="flex justify-center">
                                <div>
                                    <div class="flex justify-between text-gray-700">
                                        <p>Developed by </p>
                                        <div class="ml-4">
                                            <twitter-btn username="atymic"></twitter-btn>
                                        </div>
                                    </div>
                                    <div class="flex mt-4 justify-between text-gray-700">
                                        <p>Data by </p>
                                        <div class="ml-4">
                                            <twitter-btn username="atymic"></twitter-btn>
                                            <twitter-btn username="ai6yrham" class="ml-2"></twitter-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </modal>
                </div>
                <p class="text-gray-700 my-2 text-sm mx-2">
                    <!--                This site aims to track cruise ships during COVID-19, and provide information on their statuses.-->
                    * While we aim to provide accurate, up to date information this is not always possible as there's very little official data.
                    If you notice any issues, <a target="_blank" class="text-blue-600 hover:text-blue-700" href="mailto:covid@atymic.dev">please send us an email</a> and we'll get it corrected.
                </p>
                <div class="max-h-full">
                    <div class="flex items-center">
                        <h2 class="font-bold text-xl flex-grow">Ships</h2>
                        <div>
                            <label class="block text-gray-500 font-bold">
                                <input @change="$emit('showDisembarked')" :checked="showDisembarked" class="mr-2 leading-tight" type="checkbox">
                                <span class="text-sm">
                            Show disembarked
                          </span>
                            </label>
                        </div>
                    </div>
                    <div>
                        <vue-fuse class="border rounded outline-none focus:border-blue-300 mt-1 mb-3 p-1 w-full" placeholder="Search ships by name" :keys="['data.name']" :list="ships" :defaultAll="false" @fuseResultsUpdated="shipsSearched = $event"></vue-fuse>
                    </div>
                    <div class="">
                        <sidebar-ship @zoomShip="$emit('zoomShip', $event); open = false" v-for="ship in shipsSorted" :ship="ship" :key="ship.id"></sidebar-ship>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import SidebarShip from './SidebarShip'
  import Modal from './Modal'
  import TwitterBtn from './TwitterBtn'

  export default {
    name: 'SideBar',
    components: { TwitterBtn, Modal, SidebarShip },
    props: {
      ships: Array,
      showDisembarked: Boolean,
    },
    data() {
      return {
        open: true,
        showAbout: false,
        shipsSearched: [],
      }
    },
    computed: {
      shipsSorted () {
        let ships = this.shipsSearched.length ? this.shipsSearched : this.ships
        return ships.slice().sort((a, b) => {
            return b.data.casesPositive - a.data.casesPositive;
        })
      },
    },
  }
</script>

<style scoped>
    .sidebar {
        position: absolute;
        z-index: 500;
        margin-left: 2.5vw;
        margin-right: 2.5vw;
        margin-top: 2.5vw;
        width: 95vw;
    }

    @media screen and (min-width: 480px) {
        .sidebar {
            position: absolute;
            z-index: 9999;
            left: 0.75em;
            top: 1vh;
            height: 98vh;
            width: 30em;
            margin: 0;
        }
    }

    .h-open {
        height: 98vh;
    }
</style>
